import React from 'react';

import { IconProps } from 'icons/Icon.types';

export function Shop({ size, color }: IconProps) {
  return (
    <svg
      width={size ?? 24}
      height={size ?? 24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Shop</title>
      <path
        d="M20 4H20.75C20.75 3.58579 20.4142 3.25 20 3.25V4ZM4 4V3.25C3.58579 3.25 3.25 3.58579 3.25 4H4ZM19.25 9.90681V18H20.75V9.90681H19.25ZM4.75 18V9.90681H3.25V18H4.75ZM18 19.25H12V20.75H18V19.25ZM12 19.25H6V20.75H12V19.25ZM12 4.75H20V3.25H12V4.75ZM19.25 4V9.90681H20.75V4H19.25ZM4.75 9.90681V4H3.25V9.90681H4.75ZM4 4.75H12V3.25H4V4.75ZM3.25 18C3.25 19.5188 4.48122 20.75 6 20.75V19.25C5.30964 19.25 4.75 18.6904 4.75 18H3.25ZM19.25 18C19.25 18.6904 18.6904 19.25 18 19.25V20.75C19.5188 20.75 20.75 19.5188 20.75 18H19.25Z"
        fill={color ?? 'currentColor'}
      />
      <path
        d="M4 8C4 10.2091 5.37759 12 7.07692 12C8.08345 12 8.97709 11.3717 9.53846 10.4004C10.0998 11.3717 10.9935 12 12 12C13.0065 12 13.9002 11.3717 14.4615 10.4004C15.0229 11.3717 15.9166 12 16.9231 12C18.6224 12 20 10.2091 20 8"
        stroke={color ?? 'currentColor'}
        strokeWidth="1.5"
      />
      <path
        d="M15 20V16C15 15.4477 14.5523 15 14 15H10C9.44772 15 9 15.4477 9 16V20"
        stroke={color ?? 'currentColor'}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  );
}
